const NS = 'SiteHeaderTopWidget';
const CLS = 'siteHeaderTopWidget';

export class SiteHeaderTopWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.initCarousel();

		this.$siteHeaderWidget = this.$element.parents('.siteHeaderWidget');
		this.marketUpdateButton = this.$element.find(`.${CLS}-btn--marketUpdate`);
		this.marketUpdateButton.on('click', () => {
			this.$siteHeaderWidget.trigger(`siteHeaderWidget.${CLS}.marketUpdateButton.click`, {});
		});

		this.$element.on(`${CLS}.marketUpdateButton.toggleClass`, () => {
			this.marketUpdateButton.toggleClass(`${CLS}-btn--marketUpdate--active`);
		});

		this.$element.on(`${CLS}.marketUpdateButton.addClass`, () => {
			this.marketUpdateButton.addClass(`${CLS}-btn--marketUpdate--active`);
		});

		this.$element.on(`${CLS}.marketUpdateButton.removeClass`, () => {
			this.marketUpdateButton.removeClass(`${CLS}-btn--marketUpdate--active`);
		});

		if(this.$siteHeaderWidget.hasClass('is-logged-in')) {
			this.$loginBtn = this.$element.find(`.${CLS}-btn--login`);
			this.$loginBtn.on('click', () => {
				// if search is active, close it
				if($(document).find('.siteHeaderBottomSearchBarWidget').hasClass('active')) {
					$(document).find('.overlay').trigger('click');
				}

				// if menu (mobile) is active, close it
				if($(document).find('.siteHeaderBottomMenuWidget').hasClass('active')) {
					$(document).find('.siteHeaderBottomWidget-btn--toggler').trigger('click');
				}

				$(document).find('.personalisedDashboardWidget').addClass('active');
				$(document).find('.personalisedDashboardWidget').trigger('opened');
			});
		}
	}

	initCarousel() {
		this.$carousel = this.$element.find(`.${CLS}-carousel`);
		this.$carouselItems = this.$carousel.find(`.${CLS}-carousel-item:not(.${CLS}-carousel-item--spacer)`);
		this.$carouselViewInner = this.$carousel.find(`.${CLS}-carousel-view-inner`);
		this.$carouselPrev = this.$carousel.find(`.${CLS}-carousel-btn--prev`);
		this.$carouselNext = this.$carousel.find(`.${CLS}-carousel-btn--next`);

		this.$carouselIndex = 0;
		this.$carouselMaxIndex = this.$carouselItems.length - 1;

		let toggleButtonStatus = () => {
			if(this.$carouselIndex === 0) {
				this.$carouselPrev.addClass(`disabled`);
			}
			else {
				this.$carouselPrev.removeClass(`disabled`);
			}

			if(this.$carouselIndex === this.$carouselMaxIndex) {
				this.$carouselNext.addClass(`disabled`);
			}
			else {
				this.$carouselNext.removeClass(`disabled`);
			}
		};

		this.$carouselPrev.on('click', () => {
			if(this.$carouselIndex - 1 >= 0) {
				this.$carouselIndex -= 1;
				this.$carouselViewInner.css({
					transition: `transform 0.5s ease-in-out`,
					transform: `translateX(-${100 * this.$carouselIndex}%)`
				});
				toggleButtonStatus();
			}
		});

		this.$carouselNext.on('click', () => {
			if(this.$carouselIndex + 1 <= this.$carouselMaxIndex) {
				this.$carouselIndex += 1;
				this.$carouselViewInner.css({
					transition: `transform 0.5s ease-in-out`,
					transform: `translateX(-${100 * this.$carouselIndex}%)`
				});
				toggleButtonStatus();
			}
		});

		$(window).resize(_.debounce(() => {
			this.$carouselIndex = 0;
			this.$carouselViewInner.css({
				transition: `unset`,
				transform: `translateX(0%)`
			});
			this.$carouselPrev.addClass(`disabled`);
		}, 250));
	}
}
